import { useQuery } from '@tanstack/react-query';
import { ModalActions } from '@ui-kit/components/Modal/Modal';
import { Trans, useTranslation } from 'react-i18next';
import { AnchorButton } from '@/components/buttons';
import type { ModalProps } from '@/components/ModalRenderer/components/types';
import { Modal } from '@/components/ModalRenderer/Modal';
import { getConfig } from '@/constants/config';
import { meQueryOptions } from '@/queries/meQuery/meQuery';
import { selectUsername } from '@/queries/meQuery/meQuerySelectors';
import Button from '@/ui-kit/components/Button/Button';
import { assertCondition } from '@/utils/typescript';

const WithdrawalBlocked = ({ closeModal }: ModalProps) => {
  const { t } = useTranslation('Modal');
  const { data: username, isSuccess: isUsernameSuccess } = useQuery({
    ...meQueryOptions(),
    select: selectUsername,
  });

  if (!isUsernameSuccess) {
    return null;
  }

  assertCondition(username !== undefined, 'Username must be available when opening WithdrawalBlocked modal.');

  return (
    <Modal
      title={
        <Trans
          t={t}
          i18nKey="WithdrawalBlocked.title"
          values={{ username }}
          components={{ private: <span data-private /> }}
        />
      }
    >
      <p>{t('WithdrawalBlocked.info')}</p>
      <ModalActions>
        <Button onClick={closeModal}>{t('WithdrawalBlocked.clear')}</Button>
        <AnchorButton variant="secondary" href={getConfig().externalLinks.contact}>
          {t('WithdrawalBlocked.contactUs')}
        </AnchorButton>
      </ModalActions>
    </Modal>
  );
};

export default WithdrawalBlocked;
